var map = {
	"./ar/message.json": "./src/locales/ar/message.json",
	"./cz/message.json": "./src/locales/cz/message.json",
	"./de/message.json": "./src/locales/de/message.json",
	"./en/message.json": "./src/locales/en/message.json",
	"./es/message.json": "./src/locales/es/message.json",
	"./fr/message.json": "./src/locales/fr/message.json",
	"./hr/message.json": "./src/locales/hr/message.json",
	"./ja/message.json": "./src/locales/ja/message.json",
	"./ko/message.json": "./src/locales/ko/message.json",
	"./kz/message.json": "./src/locales/kz/message.json",
	"./pt/message.json": "./src/locales/pt/message.json",
	"./sh/message.json": "./src/locales/sh/message.json",
	"./sr/message.json": "./src/locales/sr/message.json",
	"./sv/message.json": "./src/locales/sv/message.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive ^\\.\\/.*\\/message\\.json$";